export const MAX_SIZE = 5242880;
export const MAX_COUNT = 10;
